// extracted by mini-css-extract-plugin
export default {"notification":"ShowSocketNotification__notification___CagDr","buttonContainer":"ShowSocketNotification__buttonContainer___FnYNy"};